export const createRealtimeSlice = (set) => ({
  // Cutover §3 honesty: boots at 'no-transport' — no WS/SSE connection exists
  // in this build, so the UI must not present one. The simulated heartbeat
  // that used to flip this to 'connected' from App.jsx was removed (the only
  // writer was a timer, not a transport). When the real transport lands (B7),
  // setConnectionStatus('connected' | 'connecting' | ...) is driven by it.
  connectionStatus: 'no-transport',
  lastHeartbeat: null,
  // Manual reconnect signal (S7.1): bumping reconnectNonce remounts the
  // subscription effect without a full page reload (no-op until a transport
  // is mounted in App.jsx).
  reconnectNonce: 0,
  setConnectionStatus: (connectionStatus) => set({ connectionStatus }),
  setLastHeartbeat: (lastHeartbeat) => set({ lastHeartbeat }),
  requestReconnect: () => set((state) => ({ reconnectNonce: state.reconnectNonce + 1 }))
});
